const SvgMontazScianaSufit60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="m30 3.882 24.447 12.223-.894 1.79L30 6.117 6.447 17.894l-.894-1.789z" />
    <path fill="#373737" d="M12 48v-2h12V26H12v-6l18-9 18 9v2h-6v24h6v2z" />
    <path fill="#373737" d="M14 28v2h6v14h2V28zM46 24v20h-2V24z" />
    <path fill="#373737" d="m16 32-2 3h1v3h2v-3h1zM51 40l-3-2 3-2v1h3v2h-3z" />
  </svg>;
export default SvgMontazScianaSufit60;